
import { Button } from '@/components/ui/button';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue
} from '@/components/ui/select';
import { UseMutationResult } from '@tanstack/react-query';

interface TeacherSalaryHeaderProps {
  selectedMonth: number;
  selectedYear: number;
  onMonthChange: (month: number) => void;
  onYearChange: (year: number) => void;
  calculateMonthlyReportsMutation?: UseMutationResult<any, Error, void>;
}

export function TeacherSalaryHeader({
  selectedMonth,
  selectedYear,
  onMonthChange,
  onYearChange,
  calculateMonthlyReportsMutation
}: TeacherSalaryHeaderProps) {
  return (
    <div className="flex justify-between items-center mb-6">
      <h1 className="text-2xl font-bold">เงินเดือนครู</h1>
      <div className="flex items-center space-x-4">
        <Select
          value={selectedMonth.toString()}
          onValueChange={(value) => onMonthChange(parseInt(value))}
        >
          <SelectTrigger className="w-[180px]">
            <SelectValue placeholder="เลือกเดือน" />
          </SelectTrigger>
          <SelectContent>
            {[...Array(12)].map((_, index) => (
              <SelectItem key={index + 1} value={(index + 1).toString()}>
                {index + 1}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
        <Select
          value={selectedYear.toString()}
          onValueChange={(value) => onYearChange(parseInt(value))}
        >
          <SelectTrigger className="w-[180px]">
            <SelectValue placeholder="เลือกปี" />
          </SelectTrigger>
          <SelectContent>
            {[2025, 2026].map((year) => (
              <SelectItem key={year} value={year.toString()}>
                {year}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
        <Button
          onClick={() => calculateMonthlyReportsMutation?.mutate()}
          disabled={calculateMonthlyReportsMutation?.isPending || false}
        >
          {calculateMonthlyReportsMutation?.isPending ? 'กำลังคำนวณ...' : 'คำนวณเงินเดือนทั้งหมด'}
        </Button>
      </div>
    </div>
  );
}
